import format from 'date-fns/format';
export function formatDateISO(value) {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return date.toISOString();
}
export function formatDate(value, formatString = 'do MMMM yyyy') {
    let date = value;
    if (typeof date === 'string') {
        date = new Date(date);
    }
    return format(date, formatString);
}
export function formatDateRange(valueStart, valueEnd, formatStart = 'dd MMM yy', formatEnd = 'dd MMM yy') {
    // Check if there is an end date.
    if (!valueEnd) {
        return formatDate(valueStart, formatStart);
    }
    // Parse values as JS dates.
    const dateStart = parseAsJsDate(valueStart);
    const dateEnd = parseAsJsDate(valueEnd);
    const isSameMonth = dateStart.getMonth() === dateEnd.getMonth();
    const isSameYear = dateStart.getFullYear() === dateEnd.getFullYear();
    // If they are in the same month, just use day part of start date.
    if (isSameMonth && isSameYear) {
        const formattedStart = formatDate(valueStart, 'dd');
        const formattedEnd = formatDate(valueEnd, formatEnd);
        return `${formattedStart} - ${formattedEnd}`;
    }
    // If they are in the same year, just use day & month part of start date.
    if (isSameYear) {
        const formattedStart = formatDate(valueStart, 'dd MMM');
        const formattedEnd = formatDate(valueEnd, formatEnd);
        return `${formattedStart} - ${formattedEnd}`;
    }
    // Else use entire date string for both.
    const formattedStart = formatDate(valueStart, formatStart);
    const formattedEnd = formatDate(valueEnd, formatEnd);
    return `${formattedStart} - ${formattedEnd}`;
}
/**
 * Parses a string as a JS date.
 * @param value
 * @returns
 */
function parseAsJsDate(value) {
    if (typeof value === 'string') {
        return new Date(value);
    }
    return value;
}
